// extracted by mini-css-extract-plugin
export default {"list":"Summary__list___1G2um","itemHeader":"Summary__itemHeader___LLSbf","region":"Summary__region___2Fdgl"};